












































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { PracticePass as IPracticePass } from "@/api/models/practice-pass";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { isAllowEditDates } from "@/plugins/modules-detect";
import api from "@/getinfo-api";
import { getCurrentEmployee, getCurrentUserId, isRoot } from "@/plugins/roles";

@Component({
  components: {
    CustomButton,
    CustomDatepicker,
    CustomTableCol,
    CustomTableItem
  }
})
export default class PracticePassListItem extends Vue {
  @Prop() pass!: IPracticePass;
  isShowPassedAt: boolean = false;
  passedAt: Date | undefined = this.pass.passedAt;
  showEditIcon: boolean = false;

  get formattedPracticePassStatus() {
    let status: string = "";
    if (this.pass.status === "passed")
      status = this.$tc(this.$translate.Passed);
    if (this.pass.status === "not_passed")
      status = this.$tc(this.$translate.Failed);
    if (this.pass.status === "waiting")
      status = this.$tc(this.$translate.PendingReview);
    if (this.pass.status === "send_to_revision")
      status = this.$tc(this.$translate.SentForFinalization);
    return status;
  }

  get isAllowEditDates() {
    return isAllowEditDates();
  }

  get root() {
    return isRoot();
  }

  get employee() {
    return getCurrentEmployee();
  }

  currentUserCanEdit() {
    if ((this.root || this.employee) && isAllowEditDates) {
      this.showEditIcon = true;
    }
  }

  savePassedAt() {
    if (this.passedAt)
      api.PracticeApi.editPassedAt(
        this.passedAt,
        this.pass.listener.course.id,
        this.pass.id
      )
        .then(() => {
          this.$emit("changeDate");
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
  }

  mounted() {
    this.currentUserCanEdit();
  }
}
